export default "__VITE_ASSET__CxEFru$w__"